module.exports = __webpack_public_path__ + "static/media/im.867a7ad8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/im.svg
// module id = 149
// module chunks = 0